// Vendors
import { useEffect, useMemo, useState } from 'react';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
// Enums
import { AuthScenariosEnumeration } from '../enumerations/auth-scenarios.enumeration';
// Handlers
import { AuthWatcherHandlers } from '../handlers/auth-watcher.handlers';
// Types
import { AuthWatcherHookType } from './types/auth-watcher.hook.type';

const useAuthWatcherHook = (): AuthWatcherHookType => {
  const [authConflict, setAuthConflict] = useState<AuthScenariosEnumeration | null>(null);

  const { currentState, callbackUrl, loanId, setClearAllSessionIntervalsProcesses } =
    useAppContextConsumerHook();

  const {
    handleCleanAllSessionTimersWhenSuccessEvent,
    handleSetupAllSessionTimersOnDemand,
    handleClearAllSessionIntervalsProcesses,
  } = useMemo<ReturnType<typeof AuthWatcherHandlers>>(
    () => AuthWatcherHandlers({ callbackUrl, currentState, loanId, setAuthConflict }),
    [currentState]
  );

  useEffect(() => {
    if (!authConflict) {
      handleSetupAllSessionTimersOnDemand();
    }
  }, [authConflict]); // Como hacer que se reinice los wathchers si refresca la sessión

  useEffect(() => {
    handleCleanAllSessionTimersWhenSuccessEvent();
  }, [currentState]); // Re-check when the app state changes

  useEffect(() => {
    setClearAllSessionIntervalsProcesses(() => handleClearAllSessionIntervalsProcesses);
  }, []);

  return {
    authConflict,
    setAuthConflict,
  };
};

export { useAuthWatcherHook };
